<div class="mx-auto mt-1 w-[95%] "
    *ngIf="reportObj">

    <div class="grid grid-cols-1 gap-2">
        <div class="grid-col">
            <p class="mt-1 mb-5"
                (click)="goBack()">
                <span class="cursor-pointer text-[small] p-2 bg-[#fff] rounded-xl font-bold text-[#00527E] m-2"
                      style="border: 1px solid rgb(0, 82, 126);"> 
                    VOLTAR
                </span>
            </p>

            <h2 class="text-left opacity-70 mb-4">Relatórios /  {{reportObj.object.name}} </h2>
            <h1 class="font-semibold text-lg  ">DETALHES DO RELATORIO</h1>
        </div>

        <div class="grid-col ">
            

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                <div class="border border-gray-300 p-4 rounded-xl w-full sm:w-[500px]">
                    <table class="text-sm mt-1 w-full mb-4">
                        <thead>
                            <tr class="bg-opacity-60 mb-2 pb-2">
                                <th class="min-w-[150px] text-left pr-4 py-2">Nome</th>
                                <th class="bg-white text-left pl-1 py-2">{{ reportObj.object.name }}</th>
                            </tr>
                            <tr class="bg-opacity-60 mb-2 pb-2">
                                <th class="min-w-[150px] text-left pr-4 py-2">Tipo</th>
                                <th class="bg-white text-left pl-1 py-2">{{ reportObj.object.type }}</th>
                            </tr>
                            <tr class="bg-opacity-60 mb-2 pb-2">
                                <th class="min-w-[150px] text-left pr-4 py-2">Criado em</th>
                                <th class="bg-white text-left pl-1 py-2">{{ reportObj.created_at || reportObj.tms }}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            
                <div class="border border-gray-300 p-4 rounded-xl w-full sm:w-[500px]">
                    <table class="text-sm mt-1 w-full">
                        <thead>
                            <tr class="bg-opacity-60 mb-1 pb-2">
                                <th class="pr-4 py-2 min-w-[150px] text-left pl-1">Contexto</th>
                                <th class="bg-white text-left pl-2">{{ reportObj.context }}</th>
                            </tr>
                            <tr class="bg-opacity-60 mb-1 pb-2">
                                <th class="pr-4 py-2 min-w-[150px] text-left pl-1">Contexto Id</th>
                                <th class="bg-white text-left pl-2  truncate">{{ reportObj.context_id }}</th>
                            </tr>
                            <tr class="bg-opacity-60 mb-1 pb-2">
                                <th class="pr-4 py-2 min-w-[150px] text-left pl-1">Começar em</th>
                                <th class="bg-white text-left pl-2">{{ reportObj.object.params.start_date }}</th>
                            </tr>
                            <tr class="bg-opacity-60 mb-1 pb-2">
                                <th class="pr-4 py-2 min-w-[150px] text-left pl-1">Terminar em</th>
                                <th class="bg-white text-left pl-2">{{ reportObj.object.params.end_date }}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
            

        </div>

        <div class="grid-col mt-1">
            <div class="mt-3">
                <div class="grid grid-cols-1">
                    <div class="grid grid-cols-1">
                        <div class="grid-col mb-5">
                            <button class="mt-0 mb-0"
                                *ngIf="objectList.length>0"
                                (click)="updateReports()">
                                <span class="cursor-pointer text-[small] p-2 bg-[#fff] rounded-xl font-bold text-[#00527E] m-2"
                                      *ngIf="!is_loading"
                                      style="border: 1px solid rgb(0, 82, 126);"> 
                                    Actualizar
                                </span>
                                <span class="cursor-pointer text-[small] p-2 bg-[#fff] rounded-xl font-bold text-[#00527E] m-2"
                                     *ngIf="is_loading"
                                      style="border: 1px solid rgb(0, 82, 126);"> 
                                    Aguarde...
                                </span>
                            </button>
                            <!--

                            <app-alert type="info" 
                                message="Carregando detalhes"
                                *ngIf="loadCache[currentDocOpen.fileid].Status=='LOADING'">
                            </app-alert>
                            -->

                            <app-alert type="error" 
                                message="Nao foi possivel carregar os detalhes"
                                *ngIf="is_error">
                            </app-alert>
                        </div>

                        <div class="grid-col text-center" 
                            *ngIf="objectList.length===0 && !is_loading">
                            <button class="mt-4 mb-0"
                                (click)="updateReports()">
                                <span class="cursor-pointer text-[small] p-2 bg-[#fff] rounded-xl font-bold text-[#00527E] m-2"
                                      *ngIf="!is_loading"
                                      style="border: 1px solid rgb(0, 82, 126);"> 
                                    Actualizar
                                </span>
                                <span class="cursor-pointer text-[small] p-2 bg-[#fff] rounded-xl font-bold text-[#00527E] m-2"
                                     *ngIf="is_loading"
                                      style="border: 1px solid rgb(0, 82, 126);"> 
                                    Aguarde...
                                </span>
                            </button>

                            <h3 class="text-center opacity-70">
                                Nenhum relatório pronto ainda.
                            </h3>

                            <p class="text-center opacity-70">volte + tarde.</p>
                        </div>

                        <div class="grid-col text-center" *ngIf="is_loading">
                            <div class="flex items-center rounded-xl rounded-tl-none p-[1rem] w-[7rem] ">
                                <div role="status">
                                    <svg aria-hidden="true" class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="currentColor" />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentFill" />
                                    </svg>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>

                        <div class="grid-col" *ngIf="objectList && objectList.length>0">
                            <div class="grid grid-cols-1">
                                <div class="grid-col mb-5"
                                    *ngFor="let reportGroup of objectList">
                                    <h2 class="text-left opacity-70 mb-0 text-bold">
                                        {{ reportGroup.GroupName }}
                                    </h2>
                                    <p class="text-left mb-3 opacity-70">
                                        <span style="font-size:x-small">
                                            Ultima act.: {{ reportGroup.LastUpdate }}
                                        </span>
                                        |
                                        <span style="font-size:x-small">
                                            De:  {{reportGroup.start_date}}
                                        </span>
                                        <span style="font-size:x-small">
                                            At&eacute;:  {{reportGroup.end_date}}
                                        </span>
                                    </p>

                                    <hr />

                                    <div class="grid grid-cols-3 mt-4">
                                        <div class="grid-col" 
                                            *ngFor="let object of reportGroup.list">
                                            <div class="mr-5 mb-5" >                        
                                                <div style="height: 300px;background:#f4f4f4;background-image:url('{{object.url}}');background-size:contain;background-repeat: no-repeat;background-position: center center;">
                                                </div>
                                                <div style="padding:5px;border:1px inset #ccc;border-top: 0px;">
                                                    <p>{{ object.label }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
</div>

</div>